import {
    LuBug,
    LuCalendar,
    LuCheck,
    LuChevronDown,
    LuChevronLeft,
    LuChevronUp,
    LuClock,
    LuDoorOpen,
    LuDownload,
    LuFiles,
    LuFolderDown,
    LuFolderUp,
    LuGitMerge,
    LuGrip,
    LuHouse,
    LuInfo,
    LuLink2,
    LuLink2Off,
    LuLogOut,
    LuMails,
    LuPlus,
    LuRecycle,
    LuSettings,
    LuSquarePen,
    LuTrash2,
    LuUpload,
    LuX
} from 'react-icons/lu';

import ArrowDown from './svg/arrow-down';
import Back from './svg/back';
import Edit from './svg/edit';
import Filter from './svg/filter';
import Help from './svg/help';
import Search from './svg/search';

export const BUTTON_ICONS = {
    ARROW_DOWN: ArrowDown,
    BACK: LuChevronLeft,
    CALENDAR: LuCalendar,
    CHANGE_PASSWORD: LuSquarePen,
    CHANGE_STATE: LuSquarePen,
    CHEVRON_DOWN: LuChevronDown,
    CHEVRON_UP: LuChevronUp,
    CLOCK: LuClock,
    CLOSE: LuX,
    CLOSE_2: Back,
    CONFIRM: LuCheck,
    COPY: LuFiles,
    CREATE: LuPlus,
    DELETE: LuTrash2,
    DOWNLOAD: LuDownload,
    EDIT: Edit,
    EXPORT: LuFolderUp,
    FILTER: Filter,
    HELP: Help,
    HOME: LuHouse,
    IMPORT: LuFolderDown,
    INFO: LuInfo,
    LINK: LuLink2,
    LOGOUT: LuLogOut,
    MERGE: LuGitMerge,
    OPEN: LuDoorOpen,
    OVERVIEW: LuGrip,
    RECOVER: LuRecycle,
    REPORT: LuBug,
    SEARCH: Search,
    SEED: LuUpload,
    SEND: LuMails,
    SETTINGS: LuSettings,
    UNLINK: LuLink2Off,
    UPDATE: LuSquarePen,
    UPLOAD: LuUpload
};
